import React, {Fragment} from 'react';
import {Button, Form, Grid, Header, Icon, Loader, Popup, Responsive, Segment, Tab, Table} from 'semantic-ui-react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import PaginationFront from '../../util/PaginationFront';
import SearchTableData from '../../util/SearchTableData';
import { ExportReactCSV } from '../../util/ExportCSV';
import request from "../../util/request";
import ReactExport from 'react-data-export';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

const NoDataMessage = () => <p>Nema predmeta.</p>;
const NoFilterDataMessage = () => <p>Filtriranje je uključeno! Nema predmeta.</p>;

const { ExcelFile } = ReactExport;
const { ExcelSheet } = ReactExport.ExcelFile;

export default class CourseBasics extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            archivedData: [],
            filterData: [],
            id: '',
            name: '',
            disableCreateAllImplementationsButton: false,

            loading: true,
            activeIndex:0,

            activePage: 1,
            postsPerPage: 20,
            currentPosts: [],

            results: [],

            orgUnits: [],
            orgUnit: null,
            openTable: false,
            excelData: []

        };
        this.getCourses = this.getCourses.bind(this);
        this.getDataToRender = this.getDataToRender.bind(this);
        this.createAllImplementations = this.createAllImplementations.bind(this);
        this.checkAllImplementations = this.checkAllImplementations.bind(this);
        this.handleInputChange = this.handleInputChange.bind(this);
        this.getResults = this.getResults.bind(this);
    }


    componentDidMount() {
        if(localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'){
            this.getCourses(false);
            let activeRole = localStorage.getItem('activeRole');
            window.localStorage.clear();
            localStorage.setItem('activeRole', activeRole);

            request.fetchOrgUnits()
                .then(orgUnits => this.setState({ orgUnits }));

        }
        else{
            if (localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') {this.getCourses(false);}
            if (localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') {this.checkAllImplementations();}
            let activeRole = localStorage.getItem('activeRole');
            window.localStorage.clear();
            localStorage.setItem('activeRole', activeRole);
            request.fetchOrgUnits()
                .then(orgUnits => this.setState({ orgUnits }));
        }
    }

    checkAllImplementations() {
        let obj = {};
        axios.get('semester/current')
            .then(res => res.data.id).then(id => {
                axios.get(`/course/implementations-existence-check-by-semester/${id}/`)
                    .then(res => {
                        const resData = res.data;
                        console.log('res', res.data);
                        if (resData) { this.setState({ disableCreateAllImplementationsButton: true }); }
                    })
                    .catch(err => {
                        console.log('Failed to check all implementations');
                    });
            })
            .catch(err => {
                console.log('Failed to get current semester');
            });
    }

    getCourses(archived) {
        this.setState({loading: true});
        axios.get(`course/basic/${archived}`)
            .then(res => {
                const dataa = res.data.sort((a, b) => b.name < a.name);
                this.setState({ loading: false });
                const excelData = res.data.map(el => ([
                    { value: el.name},
                    { value: el.englishName ? el.englishName : '' },
                    { value: el.comment ? el.comment : ''},
                ]));
                if(archived){
                    this.setState({ archivedData: dataa });
                    // this.setState({excelData: excelData});
                }
                else{
                    this.setState({ data: dataa })
                    this.setState({excelData: excelData});
                }
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }

    getCoursesForOrgUnit(archived) {
        this.setState({loading: true});
        axios.get(`course/basic/${localStorage.getItem('organizationalUnit')}/${archived}`)
            .then(res => {
                const dataa = res.data.sort((a, b) => b.name < a.name);
                this.setState({ loading: false });
                const excelData = res.data.map(el => ([
                    { value: el.name},
                    { value: el.englishName ? el.englishName : '' },
                    { value: el.comment ? el.comment : ''},
                ]));
                if(archived){
                    this.setState({ archivedData: dataa })
                }
                else{
                    this.setState({ data: dataa });
                    this.setState({excelData: excelData});
                }
            })
            .catch(err => {
                console.log('Failed to fetch courses');
            });
    }


    getDataToRender() {
        if (this.state.results.length !== 0) {
            return this.state.results;
        }
        else{
            if(this.state.activeIndex === 0) return this.state.data;
            if(this.state.activeIndex === 1) return this.state.archivedData;
        }
    }

    getResults(results) {
        this.setState({ results });
        this.handlePaginationChange({}, {activePage: 1})
    }


    // handleInputChange(event, { name, value }) {
    //
    //     this.setState({
    //         filterMode: true,
    //         [name]: value
    //     });
    //     let filterData;
    //     if(this.state.activeIndex === 0)  filterData= this.state.data.filter((e)=>e.name.toLowerCase().match(value.toLowerCase()))
    //     if(this.state.activeIndex === 1)   filterData= this.state.archivedData.filter((e)=>e.name.toLowerCase().match(value.toLowerCase()))
    //
    //
    //     this.setState({
    //         filterData
    //     });
    // }

    handleInputChange(event, { name, value }) {
        if ((localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') && name === 'orgUnit') {
            this.setState({activeIndex: 0})
            this.setState({data: [], archivedData: []})
            this.setState({ openTable: true });
            localStorage.setItem('organizationalUnit', value)
            this.getCoursesForOrgUnit(false);
        }
        this.setState({
            [name]: value
        });
    }

    createAllImplementations() {
        axios.post('course/create-implementations-for-current-semester/')
            .then(res => {
                toast('Kreiranje implementacija je uspješno izvršeno.');
            })
            .catch(err => {
                toast('Došlo je do greške! Kreiranje implementacija nije uspješno izvršeno.');
            });
    }

    handleTabChange = (e, { activeIndex }) => {
        this.setState({ activePage: 1, activeIndex, results: [] });

        // console.log('activeIndex', activeIndex)
        // this.setState({ filterMode: false, name:'', activeIndex, showFilterMode: false, showFiltersOnButton: false, filterData:[] })
        if(activeIndex === 1 && !this.state.archivedData.length ) this.getCourses(true);
        if(activeIndex === 1 && !this.state.archivedData.length && (localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') ) this.getCoursesForOrgUnit(true);
    }

    handlePaginationChange = (e, { activePage }) => this.setState({ activePage })


    render() {
        const headersForExport = [
            { label: 'Naziv predmeta (B/H/S jezik)', key: 'name' },
            { label: 'Naziv predmeta (Engleski jezik)', key: 'englishName' },
            { label: 'Napomena', key: 'comment' },
        ];

        const multiDataSet = [
            {
                columns: [
                    { title: 'Naziv predmeta (B/H/S jezik)', width: { wpx: 500 } },
                    { title: 'Naziv predmeta (engleski jezik)', width: { wpx: 500 } },
                    { title: 'Napomena', width: { wpx: 200 }}
                ],
                data: this.state.excelData,
            }
        ];

        // Get current posts
        const indexOfLastPost = this.state.activePage * this.state.postsPerPage;
        const indexOfFirstPost = indexOfLastPost - this.state.postsPerPage;
        const currentPosts = this.getDataToRender().slice(indexOfFirstPost, indexOfLastPost);


        const panes = [
            {
                menuItem: 'Aktivni predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    {/*{((localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') && this.state.openTable) &&*/}
                    {/*<Fragment>*/}
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                        : <div>
                            {/*<Button onClick={this.createAllImplementations} disabled={this.state.disableCreateAllImplementationsButton} color="blue" fluid>Kreiranje implementacija predmeta za čitav semestar</Button>*/}

                        {/*<Divider />*/}

                        {currentPosts.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ? 17 : 13} >
                                            <Grid columns={2} stackable>

                                                <Grid.Column width={14}>
                                                    <SearchTableData profMozilla data={this.state.data} getResults={this.getResults} filterItem={['name', 'englishName']} />
                                                </Grid.Column>
                                                <Grid.Column width={2} textAlign={'center'}>
                                                    <ExcelFile filename="Spisak predmeta" element={<Popup
                                                        trigger={<Button animated="vertical" color='green' basic floated='right' fluid style={{ textAlign: 'center' }}>
                                                            <Button.Content hidden> <Icon name="download" /></Button.Content>
                                                            <Button.Content visible>
                                                                Excel
                                                            </Button.Content>
                                                        </Button>}
                                                        content="Preuzmi spisak u Excel-u"
                                                        hideOnScroll
                                                        position="top center"
                                                    />}>
                                                        <ExcelSheet dataSet={multiDataSet} name="Predmeti" />
                                                    </ExcelFile>
                                                </Grid.Column>
                                            </Grid>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell width={1}>
                                            R. br.
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="5">
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Naziv predmeta
                                                    <Header.Subheader>B/H/S jezik</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="4">
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Naziv predmeta
                                                    <Header.Subheader>Engleski jezik</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan ="3">
                                            Napomena
                                        </Table.HeaderCell>
                                        {localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && <Table.HeaderCell colSpan="4"></Table.HeaderCell>}
                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell verticalAlign="middle" >
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan="5" >
                                            {el.name}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan="4" >
                                            {el.englishName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan ="3">
                                            {el.comment}
                                        </Table.Cell>
                                        {localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' &&
                                            <Table.Cell textAlign="center" colSpan="4" verticalAlign="middle">
                                            <Link to={{ pathname: '/predmeti/implementacije' }}>
                                                <Button
                                                    style={FiltersOnStyle}
                                                    icon
                                                    labelPosition="right"
                                                    basic="true"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => {
                                                        localStorage.setItem('courseBasicId', el.id),
                                                        localStorage.setItem('courseBasicName', el.name);
                                                        localStorage.setItem('courseComment', el.comment);
                                                        localStorage.removeItem('disableCreateImplementations')
                                                    }}
                                                >Implementacije <Icon name="folder open" /></Button>
                                                </Link>
                                        </Table.Cell>}

                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                                : <NoDataMessage />
                        }

                            <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />

                        <ToastContainer hideProgressBar />

                    </div>}
                    {/*</Fragment>}*/}
                </Tab.Pane>)
            },
            {
                menuItem: 'Arhivirani predmeti',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    {/*{((localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') && this.state.openTable) &&*/}
                    {/*<Fragment>*/}
                    {this.state.loading ? <div style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></div>
                    : <div>
                        {currentPosts.length ?
                            <Table celled selectable compact>
                                <Table.Header>
                                    <Table.Row>
                                        <Table.HeaderCell colSpan={localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' ? 15 : 12} >
                                            <div style={{paddingLeft: '30px'}}>
                                                <SearchTableData data={this.state.archivedData} getResults={this.getResults} filterItem={[ 'name', 'englishName']} />
                                            </div>
                                        </Table.HeaderCell>
                                    </Table.Row>
                                    <Table.Row>
                                        <Table.HeaderCell width={1}>
                                            R. br.
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="4">
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Naziv predmeta
                                                    <Header.Subheader>B/H/S jezik</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="4">
                                            <Header as="h4" image>
                                                <Header.Content>
                                                    Naziv predmeta
                                                    <Header.Subheader>Engleski jezik</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                        </Table.HeaderCell>
                                        <Table.HeaderCell colSpan="3" >
                                            Napomena
                                        </Table.HeaderCell>
                                        {localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && <Table.HeaderCell colSpan="3"/>}

                                    </Table.Row>
                                </Table.Header>
                                <Table.Body> {currentPosts.map((el, index) =>
                                    (<Table.Row key={el.id}>
                                        <Table.Cell verticalAlign="middle" >
                                            {(index + 1) + ((this.state.activePage - 1) * this.state.postsPerPage)}.
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan="4" >
                                            {el.name}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan="4" >
                                            {el.englishName}
                                        </Table.Cell>
                                        <Table.Cell verticalAlign="middle" colSpan="3">
                                            {el.comment}
                                        </Table.Cell>
                                        {localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && <Table.Cell textAlign="center" verticalAlign="middle" colSpan="3">
                                            <Link to={{ pathname: '/predmeti/implementacije' }}>
                                                <Button
                                                    style={FiltersOnStyle}
                                                    icon
                                                    labelPosition="right"
                                                    basic="true"
                                                    size="small"
                                                    color="blue"
                                                    onClick={() => {
                                                        localStorage.setItem('courseBasicId', el.id),
                                                            localStorage.setItem('courseBasicName', el.name);
                                                        localStorage.setItem('courseComment', el.comment);
                                                        localStorage.setItem('disableCreateImplementations', true);
                                                    }}
                                                >Implementacije <Icon name="folder open" /></Button>
                                            </Link>
                                        </Table.Cell>}

                                    </Table.Row>))}
                                </Table.Body>
                            </Table>
                                : <NoDataMessage />
                        }
                            <PaginationFront postsPerPage={this.state.postsPerPage} totalPosts={this.getDataToRender().length} paginate={this.handlePaginationChange} activePage={this.state.activePage} />

                        <ToastContainer hideProgressBar />
                    </div>}
                    {/*</Fragment>}*/}
                </Tab.Pane>)
            }
        ];

        return (
            <div>

                <Header as="h1">Predmeti</Header>
                <Segment.Group raised>
                    <Segment><Header>Spisak predmeta
                        {(localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' ||  (localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja')) ?
                            <Header style={IconHeader} floated="right" >
                            </Header> :
                        <Header style={IconHeader} floated="right" >

                            <Button

                                size="small"
                                style={FiltersOnStyle}
                                onClick={this.createAllImplementations}
                                // disabled={this.state.disableCreateAllImplementationsButton? this.state.disableCreateAllImplementationsButton: true}
                                disabled={this.state.disableCreateAllImplementationsButton}
                                color="blue" fluid
                            >
                                Kreiranje implementacija predmeta za trenutni semestar
                            </Button>

                        </Header>}

                    </Header></Segment>
                    <Segment>

                        { (localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') && <Form>
                            <Form.Group widths="equal"><Form.Field disabled={!this.state.orgUnits}>
                            <label>Organizaciona jedinica</label>
                            <Form.Dropdown
                                clearable
                                placeholder="Odaberite organizacionu jedinicu"
                                value={this.state.orgUnit}
                                onChange={this.handleInputChange}
                                name="orgUnit"
                                options={this.state.orgUnits}
                                search
                                fluid
                                selection
                            />
                        </Form.Field>
                                {/*<Form.Field />*/}
                                <Form.Field />
                            </Form.Group>

                        </Form>

                        }
                        {(((localStorage.getItem('activeRole').substr(0, 30) === 'Služba za osiguranje kvaliteta' || localStorage.getItem('activeRole').substr(0, 38) === 'Služba za nastavu i studentska pitanja') && this.state.openTable) || localStorage.getItem('activeRole').substr(0, 10) === 'Studentska' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' ) &&
                        <Tab id="myTab" menu={{ secondary: true, pointing: true, color: 'blue' }} panes={panes} onTabChange={this.handleTabChange} activeIndex={this.state.activeIndex} />}</Segment>
                </Segment.Group>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/CreateCourseImplementation/CourseBasics.js